import groq from 'groq';
import { translatedFieldQuery } from '@pkg/sanity-utils/translatedFieldQuery';

export const blockTickerFields = groq`
  ...,
  items[] {
    _type == 'onetime' => {
      name
    },
    _type == 'existing' => @->{
      name
    }
  },
  logos[]->{
    ...,
    ${translatedFieldQuery("partnerName")},
    ${translatedFieldQuery("partnerLogo")},
  }
`;
